module.exports = __webpack_public_path__ + "static/media/progress.1cba0044.jpg";